import { render, staticRenderFns } from "./moreSelect.vue?vue&type=template&id=72d1537e&scoped=true&"
import script from "./moreSelect.vue?vue&type=script&lang=js&"
export * from "./moreSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d1537e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72d1537e')) {
      api.createRecord('72d1537e', component.options)
    } else {
      api.reload('72d1537e', component.options)
    }
    module.hot.accept("./moreSelect.vue?vue&type=template&id=72d1537e&scoped=true&", function () {
      api.rerender('72d1537e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/moreSelect.vue"
export default component.exports